import { render, staticRenderFns } from "./SecureAccessEndpoints.vue?vue&type=template&id=772ec187&scoped=true&"
import script from "./SecureAccessEndpoints.vue?vue&type=script&lang=js&"
export * from "./SecureAccessEndpoints.vue?vue&type=script&lang=js&"
import style0 from "./SecureAccessEndpoints.vue?vue&type=style&index=0&id=772ec187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ec187",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772ec187')) {
      api.createRecord('772ec187', component.options)
    } else {
      api.reload('772ec187', component.options)
    }
    module.hot.accept("./SecureAccessEndpoints.vue?vue&type=template&id=772ec187&scoped=true&", function () {
      api.rerender('772ec187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/SecureAccessEndpoints.vue"
export default component.exports